import api from "./revenuePlannerApi";

const attributeConfiguration = {
  list: (accessToken) => api.get("/attributeconfiguration", accessToken),
  search: (accessToken) =>
    api.get("/attributeconfiguration/search", accessToken),
};

export default attributeConfiguration;
